import React from 'react'; 

// Size: S / M
// Disabled: true / false 
// Shape: circle / square


export const ButtonPrimary = ({content, size, disabled, shape, onClick}) => {
    
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-primary ${disabled ? ' disabled' : ''} ${shape == 'circle' ? 'circle' : shape == 'square' ? 'btn--square16' : ''}`} onClick={onClick ? onClick : null}>{content}</a>
}
export const ButtonDefault = ({content, size, disabled, shape}) => {

    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} ${disabled ? ' disabled' : ''} ${shape == 'circle' ? 'circle' : shape == 'square' ? 'btn--square16' : ''}`}>{content}</a>
}

export const ButtonSecondary = ({content, size, disabled, shape}) => {
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-secondary ${disabled ? ' disabled' : ''} ${shape == 'circle' ? 'circle' : shape == 'square' ? 'btn--square16' : ''}`}>{content}</a>
}


export const ButtonLink= ({content, size}) => {
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-link`}>{content}</a>
}

export const ButtonBlue= ({content, size}) => {
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-blue`}>{content}</a>
}

export const ButtonBlack= ({content, size}) => {
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-black`}>{content}</a>
}

export const ButtonRed= ({content, size}) => {
    return <a className={`btn ${size == 'M' ? 'btn--m' : size == 'S' ? 'btn--s' : ''} btn-red`}>{content}</a>
}